import { createElement } from "@wordpress/element";
/**
 * Internal dependencies
 */

const ToolbarButtonContainer = ({
  children,
  className
}) => createElement("div", {
  className: className
}, children);
export default ToolbarButtonContainer;
//# sourceMappingURL=toolbar-button-container.js.map